import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IAttachmentFile } from './job-attachment-preview.data';

@Component({
  selector: 'i2g-job-attachment-preview',
  templateUrl: 'job-attachment-preview.component.html',
  styleUrls: ['job-attachment-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobAttachmentPreviewComponent {
  @Input() file: IAttachmentFile;
}
